import { render, staticRenderFns } from "./SucursalCercana.vue?vue&type=template&id=2a5f57d0&scoped=true"
import script from "./SucursalCercana.vue?vue&type=script&lang=js"
export * from "./SucursalCercana.vue?vue&type=script&lang=js"
import style0 from "./SucursalCercana.vue?vue&type=style&index=0&id=2a5f57d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5f57d0",
  null
  
)

export default component.exports